import React, {  Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
	resetGEAccountNumbers,
	saveGEAccountNumbers,
	// validateAccountNumber,
	saveIsAnyValidAccountNumber,
	// saveIsAlreadyApprovedOrPending,
	disableUpdateButton,
	getSelectedAccountsPriceSource
} from '../../../redux/actions';

import {
	manipulateClipBoardToKeepNumericsOnly
} from '../../../redux/util';
import moment from 'moment';
import { PNET_USER_ROLES } from '../../common/partsNetConstants';

class AccountNumberContainers extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedAccountIndex: null
		}
		this.handleAccountNumberchange = this.handleAccountNumberchange.bind(this);
	}

	componentWillMount() {
		this.props.resetGEAccountNumbers();
	}

	handleAccountNumberchange(index, event) {
		event.preventDefault();
        const self = this;
		const accountNumber = event.target.value;
		self.props.saveIsAnyValidAccountNumber(null);
		self.props.disableUpdateButton(true);
		self.props.saveGEAccountNumbers({
			index: index + 1,
			value: accountNumber,
			valid: null,
			accountName: '',
			showLoader: false,
			isAlreadyApproved: false,
			isAlreadyPending: false,
			isOnlyGEAPartsSalesAgreementsAccount: false,
			isCheckedForSalesAgreements: false
		});
	}

	validateAccountNumber(index, event) {
		const self = this;
		const { accountNumber, isCheckedForSalesAgreements, ...rest } = self.props.state.registration.geAccountNumbers[index] || {};

		self.setState({ selectedAccountIndex: index });
		if (accountNumber && !isCheckedForSalesAgreements && !self.props.state.loading.isFetching) {
			event.target.focus();

			self.props.getSelectedAccountsPriceSource(`accountNumber=${accountNumber}&requestType=getSalesAgreementList`, priceSourceResponse => {
				if (priceSourceResponse.status && priceSourceResponse.responseObject) {
					if (priceSourceResponse.responseObject.length){
						let activeSalesAgreements = [];
						priceSourceResponse.responseObject.forEach(salesAgreement => {
							if (salesAgreement.STATUS === 'ACTIVE' &&
								(!salesAgreement.EXPIRATION_DATE || (salesAgreement.EXPIRATION_DATE && moment().isBefore(moment(salesAgreement.EXPIRATION_DATE))))
							) {
								activeSalesAgreements.push(salesAgreement);
							}
						});

						const accountName = priceSourceResponse.responseObject ? priceSourceResponse.responseObject[0].ACCOUNT_NAME : '';

						if (activeSalesAgreements.length && activeSalesAgreements.length === activeSalesAgreements.filter(salesAgreement => salesAgreement.AGREEMENT_TYPE === 'GEA Parts').length) {
							self.props.saveGEAccountNumbers({
								index: index + 1,
								value: accountNumber,
								...rest,
								accountName,
								valid: true,
								isOnlyGEAPartsSalesAgreementsAccount: true,
								isCheckedForSalesAgreements: true
							});
						} else {
							self.props.saveGEAccountNumbers({
								index: index + 1,
								value: accountNumber,
								...rest,
								accountName,
								valid: true,
								isCheckedForSalesAgreements: true
							});
						}
					} else {
						self.props.saveGEAccountNumbers({
							index: index + 1,
							value: accountNumber,
							...rest,
							valid: false,
							isCheckedForSalesAgreements: true
						});
					}
				}
			});
		}
	}

	handleChange = (index, additionalAccountDetails) => {
		const { accountNumber: value, ...rest } = this.props.state.registration.geAccountNumbers[index];

		this.props.saveGEAccountNumbers({
			index: index + 1,
			value,
			...rest,
			isCheckedForSalesAgreements: true,
			...additionalAccountDetails
		});

		if (this.state.selectedAccountIndex !== null) {
			this.setState({ selectedAccountIndex: null });
		}
	}

    render() {
		let { registration } = this.props.state;
		// let inValidAccount = false;
		let isAlreadyApprovedAccounts = [];
		let isAlreadyPendingAccounts = [];
		if(registration.geAccountNumbers.length > 0) {
			// inValidAccount = _.filter(registration.geAccountNumbers, ["valid", false]);
			// inValidAccount = inValidAccount.length === 0?false:true;
			registration.geAccountNumbers.forEach(item => {
				if(item.isAlreadyApproved) {
					isAlreadyApprovedAccounts.push(item.accountNumber);
				}
				if(item.isAlreadyPending) {
					isAlreadyPendingAccounts.push(item.accountNumber);
				}
			});
		}

		const selectedAccount = this.state.selectedAccountIndex !== null && registration.geAccountNumbers[this.state.selectedAccountIndex];

        return (
			<div>
				<div className={"errorMessageContainer "+(_.filter(registration.geAccountNumbers, ['soldToSiteAddress', false]).length > 0 || registration.isAnyValidAccountNumber === false && isAlreadyApprovedAccounts.length === 0 && isAlreadyPendingAccounts.length === 0?"show":"hide")}>
					<div className="errorMessageWrapper show">
						<p className="errorMessage">You must enter valid account number(s) below.</p>
					</div>
				</div>
				<div className={"errorMessageContainer "+(_.filter(registration.geAccountNumbers, ['showLoader', true]).length > 0 ? "show" : "hide")} >
					<div className={"errorMessageWrapper "+(_.filter(registration.geAccountNumbers	, ['showLoader', true]).length > 0 ? "show" : "hide")}>
						<p className="errorMessage">Please wait while account is being validated.</p>
					</div>
				</div>
				{isAlreadyApprovedAccounts.length > 0?
					<div className="errorMessageContainer show">
						<div className="errorMessageWrapper show">
							<p className="errorMessage">{isAlreadyApprovedAccounts.join(", ")+(isAlreadyApprovedAccounts.length>1?" are ":" is ")+" already approved."}</p>
						</div>
					</div>
				:null}
				{isAlreadyPendingAccounts.length > 0?
					<div className="errorMessageContainer show">
						<div className="errorMessageWrapper show">
							<p className="errorMessage">{isAlreadyPendingAccounts.join(", ")+(isAlreadyPendingAccounts.length>1?" are ":" is ")+" pending with Account Administrator."}</p>
						</div>
					</div>
				:null}
				{registration.geAccountNumbers.length > 0 && [...Array(registration.geAccountNumbers.length)].map((_, index) => this.props.showAddMoreAccountsLink && index >= 3 ? null :
					<div key={index} className={`accountNumberRow${registration.geAccountNumbers[index].valid === false ? ' error' : ''}`}>
						<div>
							<input
								type="text"
								size={7}
								name={`accountNumber${index + 1}`}
								value={registration.geAccountNumbers[index].accountNumber}
								onChange={this.handleAccountNumberchange.bind(this, index)}
								onPaste={(e) => manipulateClipBoardToKeepNumericsOnly((event) => {
									this.handleAccountNumberchange(index, event);
								}, e)}
								onKeyPress={this.props.acceptNumbersOnly}
								onBlur={this.validateAccountNumber.bind(this, index)}
								style={{width: '7rem'}}
							/>
							<div className={"loader account-number-loader " + (registration.geAccountNumbers[index].showLoader ? "" : "hide")}>&#160;</div>
							{registration.geAccountNumbers[index].soldToSiteAddress === false ? <p className="message">Invalid Sold To Site</p> : registration.geAccountNumbers[index].valid === false && <p className="message">Invalid Account Number</p>}
						</div>
						{registration.geAccountNumbers[index].accountName && <dl className='accountDetails'>
							{registration.geAccountNumbers[index].accountName && !registration.geAccountNumbers[index].isOnlyGEAPartsSalesAgreementsAccount && <React.Fragment>
								<dt><b>Account Name:</b></dt>
								<dd className='m-0'>{registration.geAccountNumbers[index].accountName}</dd>
							</React.Fragment>}
							{registration.geAccountNumbers[index].isOnlyGEAPartsSalesAgreementsAccount && <React.Fragment>
								<dt><label htmlFor={`company-name-${index + 1}`}><b>Company Name<span className="required">*</span>:</b></label></dt>
								<dd className='ml-0'>
									<input id={`company-name-${index + 1}`} className='companyName' type="text" value={registration.geAccountNumbers[index].companyName || ''} onChange={e => this.handleChange(index, {companyName: e.target.value})}/>
									{!(registration.geAccountNumbers[index].companyName || '').trim() && <p className="small red message my-0">Please enter Company Name</p>}
								</dd>
								<dt><label htmlFor={`user-role-${index + 1}`}><b>Role<span className="required">*</span>:</b></label></dt>
								<dd className='ml-0'>
									<select id={`user-role-${index + 1}`} value={registration.geAccountNumbers[index].userRole || ''} onChange={e => this.handleChange(index, {userRole: e.target.value})}>
										<option value='' disabled>Select a Role</option>
										{PNET_USER_ROLES.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
									</select>
									{!registration.geAccountNumbers[index].userRole && <p className="small red message my-0">Please select a Role</p>}
								</dd>
							</React.Fragment>}
						</dl>}
					</div>)}
				<p className={"addMoreAccounts " + (this.props.showAddMoreAccountsLink === true ? "show" : "hide")}><a className="noUnderline bold addMoreAccountsLink" href="#" onClick={this.props.handleAddMoreAccounts}>+ <u>Add up to 20 Accounts</u></a></p>
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	resetGEAccountNumbers: () => dispatch(resetGEAccountNumbers()),
    saveGEAccountNumbers: (data) => dispatch(saveGEAccountNumbers(data)),
    saveIsAnyValidAccountNumber: (data) => dispatch(saveIsAnyValidAccountNumber(data)),
    // saveIsAlreadyApprovedOrPending: (data) => dispatch(saveIsAlreadyApprovedOrPending(data)),
    disableUpdateButton: (data) => dispatch(disableUpdateButton(data)),
	// validateAccountNumber: (data, callback) => dispatch(validateAccountNumber(data, callback))
	getSelectedAccountsPriceSource: (queryString, callback) => dispatch(getSelectedAccountsPriceSource(queryString, callback))
});

AccountNumberContainers = connect(mapStateToProps, mapDispatchToProps)(AccountNumberContainers);
export default AccountNumberContainers;



// WEBPACK FOOTER //
// ./src/App/components/PreLogin/common/accountNumberContainers.js